// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3VFMv","alert":"SettungsInbox_alert__3VBmz"};